import { typographyStyle } from '../../../../theme/typographyStyle'
import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useAssignModalStyle = makeStyles((theme) =>
    createStyles({
        columnHeaderStyle: {
            height: 32,
            padding: theme.spacing(1),
            ...(typographyStyle(theme.typography.subtitle2) as Record<
                string,
                unknown
            >),
            fontWeight: 700,
        },
    }),
)
